function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-readings,.cls-2-readings{fill:#47a9a0;}.cls-1-readings{opacity:0.2;}.cls-3-readings{fill:#5b5b5b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "logg_out",
  "data-name": "logg out"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1-readings",
  d: "M12.32,2.73A7.66,7.66,0,1,0,20,10.39,7.66,7.66,0,0,0,12.32,2.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2-readings",
  d: "M14.43,12.33H10.21a.5.5,0,0,1-.5-.5V9a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v2.38h3.72a.5.5,0,0,1,.5.5A.51.51,0,0,1,14.43,12.33Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-3-readings",
  x1: 9.08,
  y1: 6,
  x2: 7.78,
  y2: 3.64
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3-readings",
  d: "M10.88,3.86a7.51,7.51,0,0,0-2.22.34l-.44-.8a.5.5,0,0,0-.41-.26.55.55,0,0,0-.44.21l-2,2.83a.48.48,0,0,0,0,.54A.49.49,0,0,0,5.82,7h.07L9.15,6.5a.5.5,0,0,0,.37-.74l-.36-.65a6.65,6.65,0,1,1-4.93,6.41.51.51,0,0,0-.5-.5.5.5,0,0,0-.5.5,7.66,7.66,0,1,0,7.65-7.66Z"
}));

var SvgReadings = function SvgReadings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReadings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Readings.3f2b3d04.svg";
export { ForwardRef as ReactComponent };